<template>
    <div id="sidebar-menu" style="border-top : 1px solid #eeeeee; border-right : 1px solid #eeeeee; margin-top: 11px;">
      
        <div :class="this.$route.name==='techDashboard'? 'selectedCaseAudit' : 'unselectedCaseAudit'">
            <router-link to="/tech/dashboard" class="routerLink">
                <svg-icon type="mdi" :path="this.pathHome" style="color: black; margin-right: 8px;"></svg-icon>
                <div style="color: black">Liste des audits</div>
            </router-link>
        </div>
        <div v-if="this.$route.path!='/tech/dashboard'">
        <div :class="this.$route.name==='tech-map'? 'selectedCase' : 'unselectedCase'">
            <router-link :to="{ path: `/tech/map/${this.$route.params.id}` }" class="routerLink">
                <div :class="this.$route.name==='tech-map'? 'selectedText' :'unselectedText' ">{{$t("_carte_")}}</div>
            </router-link>
        </div>
        <div :class="this.$route.name==='tech-instructions'? 'selectedCase' : 'unselectedCase'">
            <router-link :to="{ path: `/tech/instructions/${this.$route.params.id}` }" class="routerLink">
                <div :class="this.$route.name==='tech-instructions'? 'selectedText' :'unselectedText' ">{{$t("_instructions_")}}</div>
            </router-link>
        </div>
        <div :class="this.$route.name==='tech-infos'? 'selectedCase' : 'unselectedCase'">
            <!-- <router-link :to="{ path: `/tech/infos/${this.$route.params.id}` }" class="routerLink"> -->
                <!-- <div :class="this.$route.name==='tech-infos'? 'selectedText' :'unselectedText'">{{$t("_informations_generales_")}}</div> -->
            <!-- </router-link> -->
             <div class="routerLink">
                <div class="disableText">{{$t("_informations_generales_")}}</div>
             </div>
        </div>
    </div>
    <div class="unselectedCaseMode">
      <router-link class="routerLink"  :to="this.$route.path === '/tech/dashboard'? '/dashboard-audits' : '/installations/show/calepinage-agencement/' +$route.params.id" >
        <svg-icon type="mdi" :path=this.pathLaptop style="color: black; margin-right: 8px;"></svg-icon>
        <div style="color: black"> {{ $t('_passer_en_mode_analyste_') }}</div>
      </router-link>

    </div>
    </div>
</template>

<script>
    import SvgIcon from '@jamescoyle/vue-icon';
    import { mdiHomeAnalytics, mdiLaptop } from '@mdi/js';

    export default {
        components: {
            SvgIcon
        },

        data(){
            return {
                installation_id: this.$route.params.id,
                pathHome:  mdiHomeAnalytics,
                pathLaptop:  mdiLaptop
    }
  },
}
</script>

<style>

.routerLink{
    text-decoration: none;
    width: 100%;
    /* background-color: aqua; */
    display: inline-flex; 
    align-items: center; 
    padding: 5px; 
    border-radius: 4px;
}

.unselectedCaseAudit{
    height: 5vh;
    display: flex;
    align-items: center;
    border: 1px solid lightgray; 
}

.selectedCaseAudit{
    height: 5vh;
    display: flex;
    align-items: center;
    border: 1px solid lightgray; 
    background-color: #D9D9D9 ;
}

.unselectedCase{
    height: 5vh;
    display: flex;
    align-items: center;
    /* background-color: blueviolet; */
    /* border: 1px solid lightgray;  */
}

.selectedCase{
    height: 5vh;
    display: flex;
    align-items: center;
    background-color: #D9D9D9 ;
    /* border: 1px solid lightgray;  */
}

.unselectedText{
    color: black;
    margin-left: 10px;
}

.selectedText {
    color: black;
    margin-left: 10px;
    font-weight: 600 ;
}

.disableText{
    color: rgb(125, 125, 125);
    margin-left: 10px;
}
.unselectedCaseMode{
  height: 5vh;
  display: flex;
  align-items: center;
  border: 1px solid lightgray; 
  cursor: pointer;
  bottom: 0;
  position: absolute;
  width: 100%;
}
</style>